
import PreHead from '~/components/ui/PreHead.vue'
export default {
  props: {
    pageVar: {
      type: Object,
      required: true
    },
    reverse: {
      type: Boolean,
      required: false
    },
    switchColors: {
      type: Boolean,
      required: false,
      default: false
    },
    benefits: {
      type: Array,
      required: true
    }
  },
  methods: {
    onSetAnimationClass({ going }) {
      if (going === this.$waypointMap.GOING_IN && window.innerWidth > 992) {
        this.animationClass = 'animate__animated animate__fadeInUp'
      }
    }
  },
  data() {
    return {
      animationClass: '',
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0.75, 0.75]
      }
    }
  },
  computed: {
    benefitsClass() {
      return this.reverse
        ? 'col-lg-6 offset-md-1 col-md-10 col-sm-12 col-12 order-2 pt-5'
        : 'col-lg-6 col-md-10 col-lg-5 offset-md-1 offset-lg-0 col-sm-12 col-12 order-lg-1 order-2 pt-5'
    },
    infoClass() {
      return this.reverse
        ? 'col-lg-5 offset-lg-0 col-md-10 offset-md-1 col-sm-12 col-12 order-1 pb-60 pb-md-5 pb-lg-90'
        : 'col-lg-5 offset-lg-1 col-md-10 offset-md-1 col-sm-12 col-12 order-lg-2 order-1 pb-60 pb-md-5 pb-lg-90'
    },
    highlightColor() {
      if (this.switchColors) return { '--color': this.pageVar.secondaryColor }
      return {
        '--color': this.pageVar.primaryColor
      }
    },
    preHeadColor() {
      if (this.switchColors) return this.pageVar.secondaryColor
      return this.pageVar.primaryColor
    },
    backgroundColor() {
      if (this.switchColors) return this.pageVar.primaryColor
      return this.pageVar.secondaryColor
    }
  },
  components: {
    PreHead
  }
}
